import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { DashboardService } from '../dashboard/dashboard.service';
import { OpdVisitService } from './Services/OpdVisit.service';
import { AppointmentListComponent } from './appointment-list/appointment-list.component';
import { ActivatedRoute, Router} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { SiteloaderComponent } from 'app/auth/siteloader/siteloader.component';
import { Subject } from 'rxjs';
import { SearchDialogComponent } from 'app/table-list/Searchdialog/SearchDialoag.component';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'app/shared/language.service';
import { BillingserviceService } from 'app/billing/billingService.service';
import { trigger, style, animate, transition } from '@angular/animations';
import { FormControl } from '@angular/forms';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { Observable } from 'rxjs';
import { DashboardModel } from 'app/dashboard/Models/dashboard.model';
import { ShortRegistoreComponent } from 'app/billing/short-registore/short-registore.component';
import { takeUntil } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatCheckboxChange } from '@angular/material/checkbox';

export interface bill_history {
  bill_no: number;
  bill_date: string;
  bill_head: string;
  doctore: string;
  payer: string;
  create_by: string;
  net_amount: string;
  balance: string;

}
export interface surgery_advised {
  Surgery_name: string;
  eye: string;
  doctore: string;
}
export interface surgery_done {
  Surgery_name1: string;
  eye1: string;
  doctore1: string;
}
export interface Dessert {
  calories: number;
  carbs: number;
  fat: number;
  name: string;
  protein: number;
}

@Component({
  selector: 'app-opd-visits',
  templateUrl: './opdvisits.component.html',
  styleUrls: ['./opdvisits.component.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(2000, style({ opacity: 1 }))
      ])
    ])
  ]
})
export class OpdVisitsComponent implements OnInit {
  destroyopdvisit$: Subject<boolean> = new Subject<boolean>();
  @ViewChild('UHIDauto', { static: false }) private UHIDautoRef: ElementRef;
  @ViewChild('Doctorauto', { static: false }) private DoctorautoRef: ElementRef;
  @ViewChild('Categoryauto', { static: false }) private CategoryautoRef: ElementRef;
  @ViewChild('Refbyauto', { static: false }) private RefbyautoRef: ElementRef;
  @ViewChild('Reasonauto', { static: false }) private ReasonautoRef: ElementRef;
 private showspinner = false;
 private walkin = true;
 private withappointment = false;
 private selectedValue: string;
 private ShowCateName: any;
 private CatCtrl: FormControl;
 private filteredCatArray: Observable<any[]>;
 private ShowDoctorName: any;
 private DoctorCtrl: FormControl;
 private filteredDoctorArray: Observable<any[]>;
 private ShowReferdByName: any;
 private ReferedbyCtrl: FormControl;
 private filteredReferedbyArray: Observable<any[]>;
 private PartyCtrl: FormControl;
 private filteredPartyArray: Observable<any[]>;
 private opd_visits: DashboardModel[] = [];
 private selectedLanguage: any;
 private NationalityCtrl: FormControl;
 private filteredNationalityArray: Observable<any[]>;
 private selectedName: any;
 private categoryArray:any;
  constructor(private router: Router,private http: HttpClient,private authService: AuthService,
    private dashboardService: DashboardService,
    private opdvisitService: OpdVisitService, private dialog: MatDialog,
    private translate: TranslateService,
    private langservice: LanguageService,
    private activateroute: ActivatedRoute, private billingservice: BillingserviceService,private datePipe:DatePipe) {
    translate.addLangs(['en', 'fr', 'hi']);
    // translate.setDefaultLang('hi');
    // this.langservice.setlang
    this.translate.addLangs(['en', 'fr', 'hi', 'ar']);
    if (this.langservice.setlang) {
      this.translate.setDefaultLang(this.langservice.setlang);
      this.selectedLanguage = this.langservice.setlang;
    }
    else {
      this.translate.setDefaultLang('en');
    }
    this.dashboardService.moudletype
      .pipe(takeUntil(this.destroyopdvisit$))
      .subscribe((quote) => {
        if (quote == 1) {
          this.ngOnInit();
        }
      });
  }
  private panelOpenState = false;
  private index: number;
  ngOnInit() {
    this.opdvisitService.callsepecificApi='OPDVISIT';
    this.opdvisitService.apptdetail = {};
    this.opdvisitService.opdvisitmodel = {};
    this.opdvisitService.examination_details = [];
    this.opdvisitService.nextReview=null;
    this.opdvisitService.nextReviewUnit=null;
    this.opdvisitService.nextReviewNote=null;
    this.opdvisitService.opdvisitmodel.isEmergency=false;
    if (this.activateroute.snapshot.params['flag'] != "fromregister") {
      this.opdvisitService.patientdetails = {};
    }
    this.opdvisitService.patientn = null;
    //console.log("patid: " + this.opdvisitService.patientdetails.pkRegId);
    //***************************/
    this.opdvisitService.billsummary = [];
    this.opdvisitService.surgeory_advised = [];
    this.opdvisitService.surgeory_done = [];
    this.opdvisitService.opdvisitmodel.fkDoctorId = null;
    this.opdvisitService.patientdetails.fkReferredbyId = null;
    this.opdvisitService.patientdetails.fkPartyId = null;
    this.opdvisitService.partymaster_name = null;
    this.opdvisitService.opdvisitmodel.remarks = "";
    this.categoryArray =[];
    // console.log("Before API")
    //  this.opdvisitService.whatsAPp()
    this.getDoctorBrach();
    this.categoryControll();
    this.doctorControll();
    this.referedbyControll();
    this.getOpdVisitList();
    this.partyControll();
    this.nationalControll();
   this.getcategoryreturn();
  }
  getcategoryreturn(){
    this.dashboardService.getcategoryreturn().pipe(takeUntil(this.destroyopdvisit$))
    .subscribe((result) => {
      this.categoryArray =result;
      this.categoryControll();
    })
  }
 
  showOptions(event:MatCheckboxChange): void {
    this.opdvisitService.opdvisitmodel.isEmergency=event.checked ;
}
  sortData(sort: Sort) {
    const data = this.opdvisitService.billsummary.slice();
    if (!sort.active || sort.direction === '') {
      this.opdvisitService.billsummary = data;
      return;
    }

    this.opdvisitService.billsummary = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'billNo':
          return this.compare(a.billNo, b.billNo, isAsc);
        case 'billDate':
          return this.compare(a.billDate, b.billDate, isAsc);
        case 'billHead':
          return this.compare(a.billHead, b.billHead, isAsc);
        case 'branchName':
          return this.compare(a.branchName, b.branchName, isAsc);
        case 'payer':
          return this.compare(a.payer, b.payer, isAsc);
        case 'doctor':
          return this.compare(a.doctor, b.doctor, isAsc);
        case 'createBy':
          return this.compare(a.createBy, b.createBy, isAsc);
        case 'netAmount':
          return this.compare(a.netAmount, b.netAmount, isAsc);
        case 'balance':
          return this.compare(a.balance, b.balance, isAsc);
        default:
          return 0;
      }
    });
  }
  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getOpdVisitList() {
    this.dashboardService.selecteddate =this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
      this.dashboardService.getopdvisit().pipe(takeUntil(this.destroyopdvisit$)).subscribe(data => {
      this.opd_visits = data;
    });
  }

  ngDoCheck() {
    this.opdvisitService.doctors.forEach(item => {
      if (item.userId == this.opdvisitService.opdvisitmodel.fkDoctorId) {
        this.ShowDoctorName = item.userName;
      }
    });

    this.dashboardService.categories.forEach(item => {
      if (item.pkCategoryId == this.opdvisitService.opdvisitmodel.fkBillCategoryId) {
        this.ShowCateName = item.categoryName;
      }
    });
    this.opdvisitService.personmaster.forEach(item => {
      if (item.pkPersonId == this.opdvisitService.patientdetails.fkReferredbyId) {
        this.ShowReferdByName = item.personName;
      }
    });
  }
 
  categoryControll() {

    this.CatCtrl = new FormControl();
    this.filteredCatArray = this.CatCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filtercategoryfunction(cat) : this.categoryArray.slice())
      );
  }

  filtercategoryfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 5) {
      return this.categoryArray.filter(country =>
        country.categoryName?.toLowerCase().indexOf(name) === 0);
    } else {
      return this.categoryArray.filter(country =>
        country.categoryName?.toLowerCase().indexOf(name?.toLowerCase()) === 0);
    }
  }

  getcategoryobj(e: any) {
    var val = e.option.value;
    console.log(val)
    // this.ShowCateName = val.categoryName;
    this.opdvisitService.opdvisitmodel.fkBillCategoryId = val.pkCategoryId;
  }

  Checkcategorydata(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.categoryControll();
      this.opdvisitService.opdvisitmodel.fkBillCategoryId = null;
      // this.ShowCateName = null;
    }
  }
  doctorControll() {

    this.DoctorCtrl = new FormControl();
    this.filteredDoctorArray = this.DoctorCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterdoctorfunction(cat) : this.opdvisitService.doctors.slice())
      );

  }

  filterdoctorfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.opdvisitService.doctors.filter(country =>
        country.userName?.toLowerCase().indexOf(name) === 0);
    } else {

      return this.opdvisitService.doctors.filter(country =>
        country.userName?.toLowerCase().indexOf(name?.toLowerCase()) === 0);
    }

  }

  getdoctorobj(e: any) {
    var val = e.option.value;
    console.log(val)
    // this.ShowDoctorName = val.userName;
    this.opdvisitService.opdvisitmodel.fkDoctorId = val.userId;
  }

  CheckinputDoctor(event: any) {

    var checkdata = event.target.value;
    if (checkdata == "") {
      this.doctorControll();
      this.opdvisitService.opdvisitmodel.fkDoctorId = null;
      // this.ShowDoctorName = null;
    }

  }

  referedbyControll() {

    this.ReferedbyCtrl = new FormControl();
    this.filteredReferedbyArray = this.ReferedbyCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterReferedbyfunction(cat) : this.opdvisitService.personmaster.slice())
      );
  }
  newPersonArray:any=[];
  filterReferedbyfunction(value: string) {
    if(value && (typeof value != 'number')){
      const filterValue = value.toString().toLowerCase();
      const returndata= this.opdvisitService.personmaster.filter(country =>
         country.personName?.toLowerCase().indexOf(filterValue) === 0);
        if(returndata.length==0 && value.length >=3){
           this.opdvisitService.getpersonMasterSpecific('OPDVISIT',value).pipe(takeUntil(this.destroyopdvisit$)).subscribe((x:any)=>{
          this.newPersonArray =[];
          this.newPersonArray =x;
          this.filteredReferedbyArray = this.ReferedbyCtrl.valueChanges
          .pipe(
            startWith(''),
            map(cat => cat?this.checkString(cat): this.newPersonArray.slice())
          );
         })
        }else{
         return returndata;
        }  
     }
  }
  checkString(str) {   
    return this.newPersonArray ? this.newPersonArray.filter(item => item.personName.search(new RegExp(str, 'i')) > -1) : [];
   
  }
  partyControll() {
    this.PartyCtrl = new FormControl();
    this.filteredPartyArray = this.PartyCtrl.valueChanges
      .pipe(
        startWith(''),
        map(party => party ? this.filterpartyfunction(party) : this.opdvisitService.partymaster.slice())
      );
  }

  filterpartyfunction(name: string) {
    return this.opdvisitService.partymaster.filter(party =>
      party.partyName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getPartyobj(e: any) {
    let partyId = e.option.id;
    this.opdvisitService.opdvisitmodel.fkPartyId = partyId;
  }
  nationalControll() {

    this.NationalityCtrl = new FormControl();
    this.filteredNationalityArray = this.NationalityCtrl.valueChanges
      .pipe(
        startWith(''),
        map(party => party ? this.filternationalfunction(party) : this.opdvisitService.GetNationality.slice())
      );
  }

  filternationalfunction(name: string) {
    return this.opdvisitService.GetNationality.filter(party =>
      party.popupDescription.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getNatinalobj(e: any) {
    this.selectedName = e.option.value;
    var valId = e.option.id;
    this.opdvisitService.check_nationality(this.selectedName);
    this.opdvisitService.patientdetails.fkNationalityId = valId;
  }
  getreferedbyobj(e: any) {
    var val = e.option.value;
     this.ShowReferdByName = val.personName;
    this.opdvisitService.patientdetails.fkReferredbyId = val.pkPersonId;
  }

  checkinputRefreed(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.referedbyControll();
       this.ShowReferdByName = null;
      this.opdvisitService.patientdetails.fkReferredbyId = null;
    }
  }

  //get schedule type
  getDoctorBrach() {
    this.dashboardService.getall_doctors().pipe(takeUntil(this.destroyopdvisit$)).
      subscribe(data => this.success_doctors(data), err => this.failed_doctors(err));
  }

  success_doctors(data) {
    if (this.authService.masterdata.isExternal === true) {
      this.opdvisitService.doctors = data.filter(item => item.isExternal == false);
      this.doctorControll();
    }
    else {
      this.opdvisitService.doctors = data;
      this.doctorControll();
    }


  }
  failed_doctors(err) {

  }

  opensearchDialog(): void {
    // this.showspinner =true;
    this.opdvisitService.patientdetails = {};
    this.opdvisitService.checkpatient == null;
    // this.opdvisitService.get_top_200_patients().
    //   subscribe(data => this.success_top_200_patients(data), err => this.failed_top_200_patients(err));
    const dialogRef = this.dialog.open(SearchDialogComponent, {

      panelClass: 'full-width-dialog',
      maxWidth: '100vw !important',
      height: '80%',
      width: '90%',
    });

      dialogRef.afterClosed().pipe(takeUntil(this.destroyopdvisit$)).subscribe(result => {
     
      if (this.opdvisitService.patientdetails.pkRegId > 0) {
        this.walkin = true;
        this.withappointment = false;
        let patname = this.opdvisitService.patientdetails;
        this.opdvisitService.patientn = patname.firstName + ' ' + patname.lastName;
        if (patname.isExpired == true) {
          this.dashboardService.openSnackBar("This Patient is Expired ", "OK");
        }
      } else {
        this.opdvisitService.patientn = '';
      }

    });
  }

  // success_top_200_patients(data) {
  //   this.showspinner =false;
  //   this.dialog.closeAll();

  //   this.opdvisitService.patients = data;


  //   console.log("patients successfully loaded");

  //   const dialogRef = this.dialog.open(SearchDialogComponent, {

  //     panelClass: 'full-width-dialog',
  //     maxWidth: '100vw !important',
  //     height: '80%',
  //     width: '90%',
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     debugger
  //    if(result>0){
  //     this.walkin = true;
  //     this.withappointment = false;
  //     let patname = this.opdvisitService.patientdetails;
  //    this.opdvisitService.patientn = patname.firstName +' '+ patname.lastName;
  //     if (patname.isExpired == true) {
  //       this.dashboardService.openSnackBar("This Patient is Expired ", "OK");
  //     }
  //    }else{
  //     this.opdvisitService.patientn = '';
  //    }

  //   });

  // }

  failed_top_200_patients(err) {
    this.dialog.closeAll();
    // this.dashboardService.showspinner = false;

  }

  gotoregistration() {
    //this.opdvisitService.flag_from_opdvisit = true;
    // this.router.navigate(['/layout/table-list', "fromopdvisit"]);
    this.opdvisitService.checkshort = true;
    const dialogRef = this.dialog.open(ShortRegistoreComponent, {

      panelClass: 'full-width-dialog',
      maxWidth: '80vw',
      // height: '80%',
      width: '80%',
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroyopdvisit$)).subscribe(result => {

    })
  }

  //check condition 
  UHIDVliadtion: boolean = false;
  docValidation: boolean = false;
  catValidation: boolean = false;
  refValidation: boolean = false;
  reasonValidation: boolean = false;
  check_user_validation() {

    if (this.opdvisitService.patientdetails.pkRegId == null) {
      this.UHIDVliadtion = true;
      setTimeout(() => {
        this.UHIDautoRef.nativeElement.focus();
      }, 100);
      this.dashboardService.
        openSnackBar_regform("Please Enter UHID", "OK");
    }
    else if (this.opdvisitService.opdvisitmodel.fkDoctorId == null || this.ShowDoctorName == null) {
      this.docValidation = true;
      setTimeout(() => {
        this.DoctorautoRef.nativeElement.focus();
      }, 100);
      this.dashboardService.
        openSnackBar_regform("Please Select Doctor", "OK");
    }
    else if (this.opdvisitService.opdvisitmodel.fkBillCategoryId == null || this.ShowCateName == null) {
      this.catValidation = true;
      setTimeout(() => {
        this.CategoryautoRef.nativeElement.focus();
      }, 100);
      this.dashboardService.
        openSnackBar_regform("Please Select Bill Category", "OK");
    }
    else if (this.opdvisitService.patientdetails.fkReferredbyId == null ||
      this.opdvisitService.patientdetails.fkReferredbyId == 0 || this.ShowReferdByName == null) {
      this.refValidation = true;
      setTimeout(() => {
        this.RefbyautoRef.nativeElement.focus();
      }, 100);
      this.dashboardService.
        openSnackBar_regform("Please Select Referred By", "OK");
    } else if (this.opdvisitService.opdvisitmodel.remarks == null || this.opdvisitService.opdvisitmodel.remarks == "") {
      this.reasonValidation = true;
      setTimeout(() => {
        this.ReasonautoRef.nativeElement.focus();
      }, 100);
      this.dashboardService.
        openSnackBar_regform("Please Enter Reason Without Bill", "OK");
    }
    // else if (this.opdvisitService.partymaster_name == null || this.opdvisitService.partymaster_name == "" || this.opdvisitService.partymaster_name == undefined) {
    //   this.dashboardService.
    //     openSnackBar_regform("Please update Party name from Registration.", "OK");
    // } 
    else if (this.opdvisitService.opdvisitmodel.remarks.length > 70) {
      this.dashboardService.openSnackBar("Character should be more then 70.", "OK");
    }
    else {
      this.UHIDVliadtion = false;
      this.docValidation = false;
      this.catValidation = false;
      this.refValidation = false;
      this.reasonValidation = false;
      this.saveopdvisit();
    }
  }
  getpatientdetailss(event) {

    if (event > 0) {
      this.showspinner=true;
     this.opdvisitService.getpatientdetailsforReciept(event).pipe(takeUntil(this.destroyopdvisit$)).subscribe(result => {
        if(result.pkRegId >0){
          if (result.isExpired == true) {
            this.showspinner=false;
            this.clearfields();
            this.dashboardService.openSnackBar("This Patient is Expired ", "OK");
          } else {
            this.showspinner=false;
            this.opdvisitService.successpatient_details(result);
          }
        }else{
          this.showspinner=false;
          this.clearfields();
          this.dashboardService.openSnackBar("This Patient is Not Registered", "OK");
        }
       
      },err=>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } else {
          this.dashboardService.openSnackBar("API Failed","ok" );
        }
    
      });
    }

  }

  saveopdvisit() {
  
    const patient = this.opd_visits.filter(
      p => p.fK_RegID == this.opdvisitService.patientdetails.pkRegId);
    if (this.opdvisitService.patientdetails.isExpired == true) {
      this.dashboardService.openSnackBar("This Patient is Expired ", "OK");
    }

    else {
      if (patient.length > 0) {
        this.dashboardService.openSnackBar("patient already exists for todays visit", "OK");
      }
      else {
        this.dashboardService.open_loader_Dialog();
        this.save_opd_visit();
      }
      //this.opdvisitService.apptdetail = {};

    }





  }
  save_opd_visit() {
 
    this.opdvisitService.setopdobject_values();
    let partyId = this.opdvisitService.opdvisitmodel.fkPartyId == null ? 0 : this.opdvisitService.opdvisitmodel.fkPartyId;
    if (this.opdvisitService.opdvisitmodel.appId == null) {
      this.opdvisitService.opdvisitmodel.isWalkIn = true;
      let visitObj1 =
      {
        "PK_VisitId": 0,
        "FK_BranchId": this.authService.Loggeduser.branchid,
        "FK_RegID": parseInt(this.opdvisitService.opdvisitmodel.fkRegId),
        "VisitDate": this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd"),
        "VisitTime": new Date().toTimeString().split(" ")[0],
        "AgeYear": this.opdvisitService.patientdetails.ageYear != null ? this.opdvisitService.patientdetails.ageYear : 0,
        "AgeMonth": this.opdvisitService.patientdetails.ageMonth != null ? this.opdvisitService.patientdetails.ageMonth : 0,
        "AgeDays": this.opdvisitService.patientdetails.ageDays != null ? this.opdvisitService.patientdetails.ageDays : 0,
        "FK_BillCategoryId": this.opdvisitService.opdvisitmodel.fkBillCategoryId,
        "FK_PatientLocationId": 1,
        "FK_PrevLocationId": 1,
        "FK_DoctorId": this.opdvisitService.opdvisitmodel.fkDoctorId,
        "FK_AppointmentId": null,
        "IsReview": 0,
        "FK_CreatedById": this.authService.Loggeduser.userid,
        "Fk_ReferredbyID": this.opdvisitService.patientdetails.fkReferredbyId,
        "Fk_PrimaryDoctorID": this.opdvisitService.opdvisitmodel.fkDoctorId,
        "FK_PartyId": partyId !=0?partyId:null,
        "Remarks": this.opdvisitService.opdvisitmodel.remarks,
        "Fk_SpecialityIdModule":this.authService.Loggeduser.specialityId,
        "IsEmergency":this.opdvisitService.opdvisitmodel.isEmergency
      }
      this.opdvisitService.addvisitorData(visitObj1).subscribe(data =>this.success_opd_visit(data) , error =>this.failed_opd_visit(error));
      
    }
    else {
  
      var visitObj =
      {
        "PK_VisitId": 0,
        "FK_BranchId": this.authService.Loggeduser.branchid,
        "FK_RegID": parseInt(this.opdvisitService.opdvisitmodel.fkRegId),
        "VisitDate": this.datePipe.transform(new Date, "yyyy-MM-dd"),
        "VisitTime": new Date().toTimeString().split(" ")[0],
        "AgeYear": this.opdvisitService.patientdetails.ageYear != null ? this.opdvisitService.patientdetails.ageYear : 0,
        "AgeMonth": this.opdvisitService.patientdetails.ageMonth != null ? this.opdvisitService.patientdetails.ageMonth : 0,
        "AgeDays": this.opdvisitService.patientdetails.ageDays != null ? this.opdvisitService.patientdetails.ageDays : 0,
        "FK_BillCategoryId": this.opdvisitService.opdvisitmodel.fkBillCategoryId,
        "FK_PatientLocationId": 1,
        "FK_PrevLocationId": 1,
        "FK_DoctorId": this.opdvisitService.opdvisitmodel.fkDoctorId,
        "FK_AppointmentId": this.opdvisitService.opdvisitmodel.appId,
        "IsReview": 0,
        "FK_CreatedById": this.authService.Loggeduser.userid,
        "Fk_ReferredbyID": this.opdvisitService.patientdetails.fkReferredbyId,
        "Fk_PrimaryDoctorID": this.opdvisitService.opdvisitmodel.fkDoctorId,
        "FK_PartyId": partyId !=0?partyId:null,
        "Remarks": this.opdvisitService.opdvisitmodel.remarks,
        "Fk_SpecialityIdModule":this.authService.Loggeduser.specialityId,
        "IsEmergency":this.opdvisitService.opdvisitmodel.isEmergency
      }
      this.opdvisitService.addvisitorData(visitObj).subscribe(data => this.success_opd_visit(data), err => this.failed_opd_visit(err));

    
    }
    this.opdvisitService.opdvisitmodel.appId = null;
  }
 
  success_opd_visit(data) {
  
    this.dialog.closeAll();
    this.opdvisitService.datasendsms = {};
    //opd visit sms send;
    // if (this.opdvisitService.apptdetail.mobileNo != "" && this.opdvisitService.apptdetail.mobileNo != null && this.opdvisitService.apptdetail.mobileNo != undefined) {
    //   this.opdvisitService.datasendsms.PatientName = this.opdvisitService.apptdetail.firstName + ' ' + this.opdvisitService.apptdetail.lastName;
    //   this.opdvisitService.datasendsms.MobileNo = this.opdvisitService.apptdetail.mobileNo;
    //   this.opdvisitService.datasendsms.MrdNo = this.opdvisitService.apptdetail.fkRegId;
    //   this.opdvisitService.datasendsms.SeqNo = data['id'];
    //   this.opdvisitService.datasendsms.ApptDate = this.opdvisitService.apptdetail.apptDate;
    //   this.opdvisitService.datasendsms.ApptTime = this.opdvisitService.apptdetail.apptTime;
    //   this.opdvisitService.datasendsms.ApptConsultant = this.opdvisitService.appoitnmentusername;
    //   this.opdvisitService.datasendsms.SurgeryDate = null;
    //   this.opdvisitService.datasendsms.SurgeryTime = null;
    //   this.opdvisitService.datasendsms.BranchId = this.authService.Loggeduser.branchid
    //   this.opdvisitService.datasendsms.SMSType = "OPDVISIT";
    //   this.opdvisitService.sendSMstoPatient(this.opdvisitService.datasendsms);
    // }
    var queueproty = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagementApply_YN");
    var queueurl = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagementURL");
    var queuetoken = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagement_APIKey");
    if (queueproty[0]?.propertyValue =='Y' && queueurl[0]?.propertyValue !=null && queueurl[0]?.propertyValue !=undefined  && queuetoken[0]?.propertyValue !=null &&queuetoken[0]?.propertyValue !=undefined ){
      const bindname = this.opdvisitService.patientdetails?.initial !=null ? this?.opdvisitService.patientdetails?.initial +' '+this.opdvisitService.patientdetails?.firstName : this?.opdvisitService.patientdetails?.firstName;
      var queuevisitObj = {
        PK_VisitId: 0,
        FK_BranchId: this.authService.Loggeduser.branchid,
        FK_RegID: this.opdvisitService.patientdetails.pkRegId,
        VisitDate: this.datePipe.transform(new Date, "yyyy-MM-dd"),
        VisitTime: new Date().toTimeString().split(" ")[0],
        AgeYear: this.opdvisitService.patientdetails.ageYear != null ? this.opdvisitService.patientdetails.ageYear : 0,
        AgeMonth: this.opdvisitService.patientdetails.ageMonth != null ? this.opdvisitService.patientdetails.ageMonth : 0,
        AgeDays: this.opdvisitService.patientdetails.ageDays != null ? this.opdvisitService.patientdetails.ageDays : 0,
        FK_BillCategoryId: this.opdvisitService.opdvisitmodel.fkBillCategoryId,
        FK_PatientLocationId: 1,
        FK_DoctorId: this.opdvisitService.opdvisitmodel.fkDoctorId,
        FK_AppointmentId: this.opdvisitService.opdvisitmodel.appId,
        IsReview: 1,
        fk_visitid:data['id'],
        PatientName:    bindname +' '+ this.opdvisitService.patientdetails?.lastName ,
        CategoryName: this.dashboardService.categories.filter(item=>item.pkCategoryId ==this.opdvisitService.opdvisitmodel.fkBillCategoryId)[0]?.categoryName,
        Remarks: '',
        Fk_CreatedById:this.authService.Loggeduser.userid,
        Fk_RoomId:this.authService.Loggeduser.roomid,
        RoomName: this.authService.Loggeduser.room

      };
      const headers =new HttpHeaders().set( 'X-API-KEY', `${queuetoken[0]?.propertyValue}`);
            this.http.post<any>(queueurl[0]?.propertyValue + "Interface/InsertOpdVisit",queuevisitObj,{ headers }).subscribe((resp) => {
               console.log(resp);
            })
    }
    this.opdvisitService.openSnackBar("Opd Visit Created Successfully", "OK");


    this.router.navigate(['/layout/dashboard'], { replaceUrl: true });
   // this.content.next('1');
  }
  failed_opd_visit(err) {
    this.dialog.closeAll();
    if(err.status==403){
      this.opdvisitService.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }else{
      this.opdvisitService.openSnackBar("API Failed", "OK");
    }
  }
  setage(year: number, months: number, days: number, gender) {
    if (year > 0) {
      return year + "(Y)/" + gender;
    }
    else if (months > 0) {
      return months + "(M)/" + gender;
    }
    else if (days > 0) {
      return days + "(D)/" + gender;
    }
    else {
      return "";
    }
  }

  getapplist(status: number) {
    //start loading

    if (status == 2) {
      this.startloading();
     this.billingservice.getappointment(this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd"), this.authService.Loggeduser.branchid).pipe(takeUntil(this.destroyopdvisit$)).
        subscribe(data => this.success_appointments(data), err => this.failedpatient_appointments(err));
    }
    else {
      this.clearfields();

    }
  }
  ngOnDestroy(): void {
    this.destroyopdvisit$.next(true);
    this.destroyopdvisit$.unsubscribe();
    this.opdvisitService.opdvisitmodel.fkDoctorId = null;
    this.opdvisitService.opdvisitmodel.fkBillCategoryId = null;
    this.opdvisitService.opdvisitmodel.remarks = null;
    this.opdvisitService.patientn = null;
    this.selectedValue = null;
    this.walkin = null;
    this.withappointment = null;
    this.opdvisitService.billsummary = null;
    this.opdvisitService.examination_details = null;
    this.opdvisitService.surgeory_advised = null;
    this.opdvisitService.surgeory_done = null;
    this.ShowReferdByName = null;
    this.ShowCateName = null;
    this.ShowDoctorName = null;
    this.opdvisitService.partymaster_name = null;
    this.opdvisitService.opdvisitmodel.appId = null;
    this.opdvisitService.nextReview = null;
    this.opdvisitService.nextReviewUnit = null;
    this.opdvisitService.nextReviewNote = null;
    this.UHIDVliadtion = null;
    this.docValidation = null;
    this.catValidation = null;
    this.refValidation = null;
    this.reasonValidation = null;
    this.opdvisitService.opdvisitmodel.isEmergency=null;
    this.categoryArray=null;
}
  clearfields() {
    // this.opdvisitService.apptdetail  = {};
    this.opdvisitService.patientdetails = {};
    this.opdvisitService.opdvisitmodel.fkDoctorId = null;
    this.opdvisitService.opdvisitmodel.fkBillCategoryId = null;
    this.opdvisitService.patientdetails.fkReferredbyId = null;
    this.opdvisitService.opdvisitmodel.remarks = null;
    this.opdvisitService.patientn = null;
    this.selectedValue = null;
    this.walkin = true;
    this.withappointment = false;
    this.opdvisitService.billsummary = [];
    this.opdvisitService.examination_details = [];
    this.opdvisitService.surgeory_advised = [];
    this.opdvisitService.surgeory_done = [];
    this.ShowReferdByName = null;
    this.ShowCateName = null;
    this.ShowDoctorName = null;
    this.opdvisitService.partymaster_name = null;
    this.opdvisitService.patientdetails.fkPartyId = null;
    this.opdvisitService.patientdetails.fkNationalityId = null;
    this.opdvisitService.opdvisitmodel.appId = null;
    this.opdvisitService.nextReview = null;
    this.opdvisitService.nextReviewUnit = null;
    this.opdvisitService.nextReviewNote = null;
    this.UHIDVliadtion = false;
    this.docValidation = false;
    this.catValidation = false;
    this.refValidation = false;
    this.reasonValidation = false;
  }
  success_appointments(data) {
    this.finishloading();
    this.opdvisitService.appointments = data;
    console.log(this.opdvisitService.appointments);
    this.open_appointments_dialog();
  }
  failedpatient_appointments(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed","ok" );
    }

  }

  open_loader_Dialog(): void {

    const dialogRef = this.dialog.open(SiteloaderComponent, {
      width: '300px',
      panelClass: 'site-loader',
      data: {
        //  id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyopdvisit$)).subscribe(result => {

      console.log('The dialog was closed');
      //pid = result;
    });
  }

  startloading() {
    this.open_loader_Dialog();
    // this.dashboardService.showspinner = true;
  }

  finishloading() {
    this.dialog.closeAll();
    // this.dashboardService.showspinner = false;
  }

  getdatabyreferal(data) {
    console.log(data);

  }

  open_appointments_dialog(): void {
    const dialogRef = this.dialog.open(AppointmentListComponent, {

      panelClass: 'full-width-dialog',
      maxWidth: '100vw !important',
      height: '90%',
      width: '90%',

      data: {

      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyopdvisit$)).subscribe(result => {
     if(result){
      this.ShowDoctorName =this.opdvisitService.appoitnmentusername;
      if(result.referredDoctor.length >0){
        this.dashboardService.subscriptions=  this.opdvisitService.getpersonMasterSpecific('OPDVISIT',result.referredDoctor).subscribe((x:any)=>{
          this.newPersonArray =[];
          this.newPersonArray =x;
          this.opdvisitService.patientdetails.fkReferredbyId =x[0]?.pkPersonId;
          this.ShowReferdByName=x[0]?.personName;
          this.filteredReferedbyArray = this.ReferedbyCtrl.valueChanges
          .pipe(
            startWith(''),
            map(cat => cat?this.checkString(cat): this.newPersonArray.slice())
          );
         })
      }
      
     }
     
      //pid = result;
    });
  }

}
